import { render } from "./ModalBoxAlert.vue?vue&type=template&id=5fe062b6"
import script from "./ModalBoxAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalBoxAlert.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/ModalBoxAlert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5fe062b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5fe062b6', __exports__)) {
    api.reload('5fe062b6', __exports__)
  }
  
  module.hot.accept("./ModalBoxAlert.vue?vue&type=template&id=5fe062b6", () => {
    api.rerender('5fe062b6', render)
  })

}


export default __exports__